"use strict";
import React from "react";
import { Link } from "react-router-dom";
import Moment from "moment-timezone";
import { BootstrapTable, TableHeaderColumn } from "../lib/react-bootstrap-table.js";
import Paiger from "./paiger";
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Grid extends React.Component {
    static propTypes = {
        markSortableColumns: PropTypes.bool
    };

    static defaultProps = {
        markSortableColumns: false
    };

    state = {
        selected: [],
        selectAll: false
    };

    onChangePage = (page) => {
        $("html, body").scrollTop($('.content-header').offset().top - 30);
        this.props.onChangePage(page);
    }

    onChangePageSize = (pageSize) => {
        $("html, body").scrollTop($('.content-header').offset().top - 30);
        this.props.onChangePageSize(pageSize);
    }

    onSort = (sortName, sortOrder) => {
        this.props.onSort(sortName, sortOrder);
    }

    onRowSelect = (data) => {
        let state = this.state
        let index = state.selected.indexOf(data)
        if (index == -1) {
            state.selected.push(data);
        } else {
            state.selected.splice(index, 1);
        }
        this.props.onRowSelect(data);
        this.setState({ selected: state.selected })
    }

    selectAllRows = () => {
        let rows = this.props.data
        let state = this.state
        for (var i = 0; i < rows.length; i++) {
            if (state.selectAll) {
                if (state.selected.indexOf(rows[i]) > -1) {
                    this.onRowSelect(rows[i]);
                }
            } else {
                if (state.selected.indexOf(rows[i]) == -1) {
                    this.onRowSelect(rows[i]);
                }
            }
        }
        this.setState({ selectAll: !state.selectAll })
    }

    renderCaret = (direction) => {
        const { markSortableColumns } = this.props;

        if (direction && direction.toLowerCase() === 'asc') {
            return <i className="fa fa-fw fa-sort-asc"></i>;
        }
        if (direction && direction.toLowerCase() === 'desc') {
            return <i className="fa fa-fw fa-sort-desc"></i>;
        }

        return markSortableColumns
            ? <i className="fa fa-fw fa-sort"></i>
            : null;
    }

    customHeaderClass = (sortTerm, columnField, headerClass = "") => {
        if (sortTerm == columnField) {
            return `sort-column-sorted ${headerClass}`;
        }
        else {
            return headerClass;
        }
    }

    documentFormatter = (cell, row) => {
        // cell with document array
        var docCount = cell ? cell.length : 0;
        var docArray = cell;
        var docLinks = docCount > 0 ? docArray.map(function (d, index) {
            var code = _.replace(d.code, "_", " ").toLowerCase();
            if (code == "turninreceipturl") {
                code = "Turn In Receipt";
            }
            if (code == "conditionreport") {
                code = "Condition Report";
            }

            if (code === 'payoffreceipt') {
                code = 'Payoff Receipt';
            }

            if (code === 'payofffundingreceipt') {
                code = 'Funding Confirmation Receipt';
            }

            var fileName = d.mimeType == 'text/html' ? false : d.code + ".pdf";

            return <div className="historyDocument" key={d.code + index}>
                <Link to={d.url} download={fileName} target="_blank">
                    <span className="glyphicon glyphicon-save-file"></span>{code}
                </Link>
            </div>
        }) : "";
        return <div>{docLinks}</div>;
    }

    linkFormatter = (cell, row) => {
        // cell
        return <div><Link to={cell.url} className="icon-link">{cell.code}</Link><br /></div>;
    }

    routeFormatter = (cell, row) => {
        return <div><a href={cell.url} className={cell.className}>{cell.content}</a></div>
    }

    actionsFormatter = (cell, row) => {
        var actionLink = cell != "" ? <Link to={cell}>Arbitrate</Link> : "Arbitration window closed"; //{cell}
        return <div>{actionLink}</div>;
    }

    vdpFormatter = (cell, row) => {
        var vdpLink = cell;

        if (row.listingId && row.listingId != '') {
            var listing = "/listing/vdp/" + row.listingId;
            vdpLink = <Link to={listing}>{cell}</Link>;
        }
        return <div className="show">{vdpLink}</div>
    }

    descriptionFormatter = (cell, row) => {
        //<Link to={"/listing/vdp/" + row.listingId} className="icon-link">{description}</Link>
        let description = cell;
        let listing = row.listingUrl !== null ? <div>
            <Link to={row.listingUrl}>{description}</Link>
        </div> : <div>
                <span>{description}</span>
            </div>
        //return <a className="vehicle-name" href={"/listing/vdp/" + row.listingId}>{description}</a>;
        return listing;
    }

    odometerFormatter = (cell, row) => {
        return <div className="show">{cell}</div>;
    }

    currencyFormatter = (cell, row) => {
        let value = new Number(cell);
        value = value.toFixed(0).replace(/./g, function (c, i, a) {
            return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
        });

        return '$' + value;
    }

    rawDateFormatter = (cell, row) => {
        let value = Moment.utc(cell);
        value = Moment(value).local().format('MM/DD/YYYY');
        return value;
    }

    dateTimeFormatter = (cell, row) => {
        let value = Moment.utc(cell);
        if (value.isValid()) {
            value = Moment(value).local().format('MM/DD/YYYY h:mm A');
        }
        else {
            value = cell;
        }

        return value;
    }

    dateFormatter = (cell, row) => {
        let value = Moment.utc(cell)
        value = Moment(value).local().format('MM/DD/YYYY');
        return value;
    }

    sentByDisplayFormatter = (cell, row) => {
        return cell.createdBy
    }

    reportingDateFormatter = (cell, row) => {
        let value = Moment(cell);
        if (value.isValid()) {
            value = Moment(value).local().format('MM/DD/YYYY');
        } else {
            value = cell;
        }

        return value;
    }

    selectFormatter = (cell, row, formatExtraData) => {
        let additionalProps = {};
        if (formatExtraData && formatExtraData.getAdditionalProps) {
            additionalProps = formatExtraData.getAdditionalProps(row);
        }
        // Not sure if this is better than just having the grid keep track...
        let state = this.state;
        var isSelected = state.selected.indexOf(row) >= 0;
        return <div><input id="select" type="checkbox" onClick={() => this.onRowSelect(row)} checked={isSelected} {...additionalProps} /></div>;
    }

    expandFormatter = (cell, row) => {
        return <div className="cell-expand__modify-size" onClick={(e) => this.props.onRowExpand(e, row)}>{cell}</div>;
    }

    modalDisplayFormatter = (cell, row) => {
        return <div><a onClick={() => this.props.displayModal(row)}>{cell}</a></div>;
    }

    thumbnailFormatter = (cell, row) => {
        return cell ? <img src={cell} style={{ height: '65', width: '82' }} /> : <div className="noImage" style={{ height: '65', width: '82', backgroundSize: '100%' }}></div>;
    }

    stringFormatter = (cell, row) => {
        return cell;
    }

    contentFormatter = (cell) => {
        return cell.content;
    }

    proxyFormatter = (cell, row, formatExtraData) => {
        if (formatExtraData && formatExtraData.getDataFormat) {
            const formatterName = formatExtraData.getDataFormat(row);
            const formatter = this.getFormatter(formatterName);

            return formatter(cell, row);
        }
    }

    openDetailFormatter = (cell, row) => {
        return <Link target="_blank" to={`${this.props.detailUrl}/${row.key}`}>{cell}</Link>;
    }

    getFormatter = (formatter) => {
        if (typeof (formatter) == "function") {
            return formatter;
        }
        else if (formatter === "proxy") {
            return this.proxyFormatter;
        }
        else if (formatter === "content") {
            return this.contentFormatter;
        }
        else if (formatter === "currency") {
            return this.currencyFormatter;
        }
        else if (formatter === "reportingDate") {
            return this.reportingDateFormatter;
        }
        else if (formatter === "date") {
            return this.dateFormatter;
        }
        else if (formatter === "dateTime") {
            return this.dateTimeFormatter;
        }
        else if (formatter === "rawDate") {
            return this.rawDateFormatter;
        }
        else if (formatter === "vdp") {
            return this.vdpFormatter;
        }
        else if (formatter === "description") {
            return this.descriptionFormatter;
        }
        else if (formatter === "link") {
            return this.linkFormatter;
        }
        else if (formatter === "route") {
            return this.routeFormatter;
        }
        else if (formatter === "odometer") {
            return this.odometerFormatter;
        }
        else if (formatter === "document") {
            return this.documentFormatter;
        }
        else if (formatter === "actions") {
            return this.actionsFormatter;
        }
        else if (formatter === "thumbnail") {
            return this.thumbnailFormatter;
        }
        else if (formatter === "select") {
            return this.selectFormatter;
        }
        else if (formatter === "sentBy") {
            return this.sentByDisplayFormatter;
        }
        else if (formatter === "modal") {
            return this.modalDisplayFormatter;
        }
        else if (formatter === "openDetail") {
            return this.openDetailFormatter;
        }
        else if (formatter === "expand") {
            return this.expandFormatter;
        }
        else {
            return this.stringFormatter;
        }
    }

    expandColumnComponent({ isExpandableRow, isExpanded }) {
        return isExpandableRow && <div className={classNames({'panel-close-row': !isExpanded, 'panel-open-row': isExpanded})}></div>
    }

    render() {
        // http://allenfang.github.io/react-bootstrap-table/docs.html
        // Table
        let dataSource = this.props.data || [];
        let columns = this.props.columns || [];
        let options = {
            onSortChange: this.onSort,
            defaultSortName: this.props.sortName,
            defaultSortOrder: this.props.sortOrder,
            expandBy: this.props.expandBy
        };
        let sortTerm = this.props.sortTerm || '';

        // Paiger
        const currentPage = this.props.currentPage || 1;
        const pageSize = this.props.pageSize || 25;
        const totalRecords = this.props.totalRecords || 0;
        const totalPages = Math.ceil(totalRecords / pageSize);
        const resultPerPages = this.props.resultPerPages;

        let paiger = this.props.showPaiger && <Paiger totalPages={totalPages}
            currentPage={currentPage}
            pageSize={pageSize}
            onChangePage={this.onChangePage}
            onChangePageSize={this.onChangePageSize} 
            resultPerPages= {resultPerPages} />;

        let condensed = _.isNil(this.props.condensed)
            || this.props.condensed;
        let bordered = _.isNil(this.props.bordered)
            || this.props.bordered;

        return (
            <div className="tableContainer">
                <BootstrapTable data={dataSource}
                    condensed={condensed}
                    bordered={bordered}
                    trClassName={this.props.getRowClassName}
                    hover={true}
                    remote={true}
                    tableContainerClass={this.props.tableContainerClass}
                    expandableRow={this.props.isExpandableRow}
                    expandComponent={this.props.expandComponent}
                    expandColumnOptions={{
                      expandColumnVisible: typeof this.props.isExpandableRow === 'function' ? this.props.isExpandableRow() : false,
                      expandColumnComponent: this.expandColumnComponent,
                      columnWidth: 25
                    }}
                    options={options}>
                    {
                        columns.map((column, i) => {
                            const key = `row_` + i;
                            let formatter = this.getFormatter(column.dataFormat);
                            if ((column.dataFormat === "select" && !column.name && !column.hideSelectAll) || React.isValidElement(column.name)) {
                                column.name = <input type="checkbox" onChange={this.selectAllRows} />
                            }
                            let width = !column.width || column.width == undefined ? "100" : column.width;
                            const caretRender = column.isSortable
                                ? this.renderCaret
                                : () => null;

                            return (
                                <TableHeaderColumn width={width}
                                    key={key}
                                    formatExtraData={column.formatExtraData}
                                    dataField={column.dataField}
                                    isKey={column.isKey}
                                    hidden={column.isHidden}
                                    dataFormat={formatter}
                                    className={this.customHeaderClass(sortTerm, column.dataField, column.headerClasses)}
                                    dataSort={column.isSortable}
                                    caretRender={caretRender}
                                    columnClassName={column.columnClassName}
                                    expandable={false}
                                    dataAlign={column.dataAlign || "left"}>
                                    {column.name}
                                </TableHeaderColumn>
                            );
                        })
                    }
                </BootstrapTable>
                <div>
                    {paiger}
                </div>
            </div>
        )
    }
}

Grid.displayName = 'Grid';

Grid.defaultProps = {
    showPaiger: true
};

module.exports = Grid;